import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery, Transition } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: ${Transition.OPACITY_EASE};
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  align-items: center;
  margin-bottom: 150px;

  ${MediaQuery.L_AND_DOWN} {
    padding: 0 30px;
    margin-bottom: 100px;
  }
`;

export const Title = styled.h2`
  ${Typography.XXXXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin-bottom: 50px;
  text-align: center;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  ${MediaQuery.L_AND_DOWN} {
    flex-direction: column;
  }
`;
